<template>
    <div class="mbb-records-list fadeInRight">
        <div class="title-box clearfix">
            <span class="m-title">代理商资源记录</span>
            <el-form
                inline
                class="right themed-form search-form"
                :model="form"
                style="line-height: 40px"
            >
                <el-form-item label="代理商:">
                    <AgentSelect
                        :multiple="false"
                        v-model="form.agentId"
                        :placeholder="'全部'"
                    />
                </el-form-item>
                <el-form-item label="充值类型:">
                    <el-select
                        v-model="form.changeType"
                        clearable
                        placeholder="全部"
                    >
                        <el-option label="全部" value="" />
                        <el-option label="充值" value="1" />
                        <el-option label="退款" value="2" />
                    </el-select>
                </el-form-item>
                <el-form-item label="iccid:">
                    <el-input
                        v-model="form.iccid"
                        placeholder="请输入卡号或短号"
                    />
                </el-form-item>
                <el-form-item label="套餐名称:">
                    <el-input
                        v-model="form.mealName"
                        placeholder="请输入套餐名称"
                    />
                </el-form-item>
                <el-form-item label="开始时间:">
                    <el-date-picker
                        style="width: 100%"
                        placeholder="请选择开始时间"
                        v-model="form.startTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    />
                </el-form-item>
                <el-form-item label="结束时间:">
                    <el-date-picker
                        style="width: 100%"
                        placeholder="请选择结束时间"
                        v-model="form.endTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        class="themed-button"
                        @click="onSearch"
                        v-preventReClick
                        >搜索查询</el-button
                    >
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        class="themed-button"
                        @click="exportChange"
                        v-preventReClick
                        >导出</el-button
                    >
                </el-form-item>
            </el-form>
        </div>

        <div class="content-box">
            <el-table
                ref="table"
                :data="tableData"
                stripe
                border
                :max-height="maxTableHeight"
            >
                <el-table-column
                    label="代理商"
                    prop="agentName"
                    show-overflow-tooltip
                />
                <el-table-column label="套餐名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{
                            scope.row.mealName || scope.row.packageName || ""
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="充值类型"
                    prop="changeType"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{
                            formatChangeType(scope.row.changeType)
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="资源点数量"
                    prop="pointsChange"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="操作人"
                    prop="operator"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="卡号"
                    prop="iccid"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="短号"
                    prop="shortIccid"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="备注"
                    prop="remark"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="创建时间"
                    prop="createTime"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="更新时间"
                    prop="updateTime"
                    show-overflow-tooltip
                />
            </el-table>
        </div>

        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 50, 100, 1000]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            />
        </div>
    </div>
</template>

<script>
import resize from "@/mixins/resize.js";
import AgentSelect from "@/components/AgentSelect.vue";
import { listRecords, exportRecords } from "@/api/MbbManagement/recordsList.js";
import { agentListForUser } from "@/api/cardManagement/cardBill.js";

export default {
    name: "MbbRecordsList",
    mixins: [resize],
    components: { AgentSelect },
    data() {
        return {
            form: {
                agentId: "",
                changeType: "",
                iccid: "",
                mealName: "",
                startTime: "",
                endTime: "",
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            // 用于根据 agentId 反查 agentName
            agentOptions: [],
        };
    },
    mounted() {
        this.getList();
        this.fetchAgentOptions();
    },
    methods: {
        // 列表
        getList() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form,
            };
            listRecords(params).then((res) => {
                if (res && res.page) {
                    this.tableData = res.page.rows || [];
                    this.total = res.page.total || 0;
                    this.currentPage = res.page.pageNo || 1;
                } else {
                    this.tableData = [];
                    this.total = 0;
                }
            });
        },
        // 搜索
        onSearch() {
            this.currentPage = 1;
            this.getList();
        },
        // 分页
        handleSizeChange(v) {
            this.pageSize = v;
            this.getList();
        },
        handleCurrentChange(v) {
            this.currentPage = v;
            this.getList();
        },
        // 类型显示
        formatChangeType(v) {
            const val = v != null ? String(v) : "";
            if (val === "1" || v === 1 || v === "充值") return "充值";
            if (val === "2" || v === 2 || v === "退款") return "退款";
            return "";
        },
        // 代理商选项（用于导出时取名称）
        fetchAgentOptions() {
            agentListForUser()
                .then((res) => {
                    this.agentOptions = Array.isArray(res) ? res : [];
                })
                .catch(() => {
                    this.agentOptions = [];
                });
        },
        // 导出
        exportChange() {
            // 根据 agentId 获取 agentName
            let agentName = "";
            if (this.form.agentId) {
                const agent =
                    this.agentOptions.find(
                        (it) => (it.agentId || it.id) === this.form.agentId
                    ) || {};
                agentName = agent.agentName || agent.name || "";
            }

            let params = {
                agentId: this.form.agentId || "",
                agentName: agentName,
                status: "", // 当前页面没有 status 字段，设为空字符串
            };
            exportRecords(params).then(res => {
                if (res.system_result_key == '0') {
                    this.$alert('导出成功，请到导出记录中下载', '提示', {
                        confirmButtonText: '确定',
                    }).then(() => {
                        this.$router.push('/tob/i_export_list');
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    });
                }
            });
        },
    },
};
</script>

<style scoped>
.mbb-records-list {
    padding: 20px;
}
.content-box {
    margin-bottom: 20px;
}
.pagination {
    text-align: right;
    margin-top: 20px;
}
.mbb-records-list /deep/ .el-form--inline .el-form-item__content {
    vertical-align: middle;
}
</style>


